document.addEventListener("DOMContentLoaded", () => {
    const headings = document.querySelectorAll(".home-faq-heading p");
    const contents = document.querySelectorAll(".home-faq-tabs .home-faq-content");
    headings.forEach((heading, index) => {
        heading.addEventListener("click", () => {
            headings.forEach(h => h.classList.remove("active"));
            contents.forEach(c => c.classList.remove("active"));
            heading.classList.add("active");
            if (contents[index]) {
                contents[index].classList.add("active");
            }
        });
    });
});

//show more for 1st question
function seeMore(i) {
    var dots = document.getElementById(`dots${i}`);
    var moreText = document.getElementById(`more${i}`);
    var btnText = document.getElementById(`myBtn${i}`);
    if (dots.style.display === "none") {
        dots.style.display = "inline";
        btnText.innerHTML = "show more";
        moreText.style.display = "none";
    } else {
        dots.style.display = "none";
        btnText.innerHTML = "show less";
        moreText.style.display = "inline";
    }
    // recalculate height
    document.getElementById(`more${i}`).parentElement.style.height = 'fit-content';
}